import { formatAmountWithCurrency } from '@/utils/numberFormat';

const sanitizeRateValue = (rawRate) => {
  const numeric = Number(rawRate);
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return 0;
  }

  // Some payloads deliver rate as decimal (0.16) and others as percent (16).
  return numeric > 0 && numeric <= 1 ? numeric * 100 : numeric;
};

const resolveRawRateFromTaxItem = (taxItem) => {
  if (!taxItem || typeof taxItem !== 'object') {
    return 0;
  }

  const directRate = Number(
    taxItem.rate
    ?? taxItem.percentage
    ?? taxItem.percent
    ?? 0
  );
  if (Number.isFinite(directRate) && directRate > 0) {
    return directRate;
  }

  const quotaRate = Number(taxItem.tasa_o_cuota ?? taxItem.tasaocuota ?? 0);
  if (Number.isFinite(quotaRate) && quotaRate > 0) {
    return quotaRate;
  }

  return 0;
};

const formatRateLabel = (rawRate) => {
  const rate = sanitizeRateValue(rawRate);
  if (rate <= 0) {
    return '';
  }

  const normalized = Math.round(rate * 10000) / 10000;
  const display = Number.isInteger(normalized)
    ? String(normalized)
    : String(normalized).replace(/\.?0+$/, '');

  return `${display}%`;
};

const appendRateToTaxName = (name, rawRate) => {
  const taxName = String(name || '').trim() || 'Impuesto';
  if (/%/.test(taxName)) {
    return taxName;
  }

  const rateLabel = formatRateLabel(rawRate);
  if (rateLabel === '') {
    return taxName;
  }

  return `${taxName} ${rateLabel}`;
};

export const formatTaxLine = (taxItem, currency) => {
  const direction = String(taxItem?.direction || '').trim().toLowerCase();
  const sign = direction === 'retenido' ? '-' : '+';
  const taxName = appendRateToTaxName(
    String(taxItem?.name || taxItem?.code || 'Impuesto').trim(),
    resolveRawRateFromTaxItem(taxItem),
  );
  const amount = Number(taxItem?.amount || 0) || 0;

  return `${sign} ${taxName}: ${formatAmountWithCurrency(amount, currency)}`;
};
